// Copyright (c) 2019 Deere & Company

import '../create-claim-modal/create-claim-modal.scss';
import React, {PropTypes} from 'react';
import Warranty from '@deere/cps-it.warranty-model-factory/lib/warranty';
import {WarrantyMediumModal} from '../../../shared/components/modal';
import WarrantyStatusModalBody from './warranty-status-modal-body';
import WarrantyStatusModalHeader from './warranty-status-modal-header';

const WarrantyStatusModal = props =>
    <WarrantyMediumModal
        className='create-claim-modal'
        isOpen={props.isModalOpen}
    >
        <WarrantyStatusModalHeader
            onCloseButtonClick={props.onCloseButtonClick}
            pin={props.pin}
            warrantiesLength={props.warranties.length}
        />
        <WarrantyStatusModalBody
            warranties={props.warranties}
        />
    </WarrantyMediumModal>;

WarrantyStatusModal.displayName = 'WarrantyStatusModal';
WarrantyStatusModal.propTypes = {
    isModalOpen: PropTypes.bool.isRequired,
    onCloseButtonClick: PropTypes.func.isRequired,
    pin: PropTypes.string.isRequired,
    warranties: PropTypes.arrayOf(PropTypes.instanceOf(Warranty)).isRequired
};

export default WarrantyStatusModal;



// WEBPACK FOOTER //
// ./src/shared/components/warranty-status-modal/index.js